import { useState, useContext, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import './App_1.css';
import {BrowserRouter, Routes, Route} from "react-router-dom";

import { MyContext } from "./MainContext";

import AuthPage from './pages/authPage';
import Home from "./pages/home";
import Profile from "./pages/profile";
import Insight from "./pages/insight";

import SearchPage from "./pages/search";

import AboutPage from "./pages/about";
import PrivacyPage from "./pages/privacy_policy";
import TermsPage from "./pages/terms_of_service";
import ChildSafetyStandardsPage from "./pages/child_safety_standards";
import DonatePage from "./pages/donate";
import MobileAppPage from "./pages/mobile_app";

import PrayerRequestsPage from "./pages/prayer";
import TherapyPage from "./pages/therapy_new";
import CounsellingPage from "./pages/Counselling";
import Dashboard from "./pages/dashboard";
import TherapistDashboard from "./pages/therapist_dashboard";
import ClientDashboard from "./pages/client_dashboard";
import WalletPage from "./pages/wallet_page";
import MyTherapySessions from "./pages/my_therapy_sessions";
import Groups from "./pages/groups";
import Group from "./pages/group";
import GroupDetail from "./components/GroupDetail";
import GroupAnnouncements from "./components/GroupAnnouncements";
import GroupMembers from "./components/GroupMembers";
import GroupDepartments from "./components/GroupDepartments";
import DepartmentDetail from "./components/DepartmentDetail";
import DepartmentAnnouncements from "./components/DepartmentAnnouncements";
import DepartmentGoals from "./components/DepartmentGoals";
import GroupPrayerRequests from "./components/GroupPrayerRequests";
import GroupTherapy from "./components/GroupTherapy";
import GroupCounselling from "./components/GroupCounselling";
import GroupCounsellingAdmin from "./pages/GroupCounsellingAdmin";
import GroupGoals from "./components/GroupGoals";
import GroupChat from "./components/GroupChat";
import GoalsDashboard from "./pages/goals";
import CounsellorDashboard from "./pages/CounsellorDashboard";
import PublicGroupView from "./components/PublicGroupView";
import FindChurch from "./pages/FindChurch";
import MessagesPage from "./pages/messages";
import MessageRequestsPage from "./pages/messageRequests";
import ChatPage from "./pages/chat";

import UpdateNotification from "./components/UpdateNotification";
import NotificationToast from "./components/NotificationToast";
import OpenJoinInApp from "./components/OpenJoinInApp";
import OpenInsightInApp from "./components/OpenInsightInApp";


function App() {

  const {setUser, user} = useContext(MyContext);


  return (
  
         <BrowserRouter>
         <OpenJoinInApp />
         <OpenInsightInApp />
         
        <Routes>

          {!user.user_id && <Route path="/" element={<AuthPage />} />}
          {user.user_id && <Route path="/" element={<Home />} />}

          {!user.user_id && <Route path="/prayers" element={<AuthPage />} />}
          {user.user_id && <Route path="/prayers" element={<PrayerRequestsPage />} />}
          
          {!user.user_id && <Route path="/therapy" element={<AuthPage />} />}
          {user.user_id && <Route path="/therapy" element={<TherapyPage />} />}
          {user.user_id && <Route path="/counselling" element={<CounsellingPage />} />}

          {/* My Therapy Sessions Route */}
          {!user.user_id && <Route path="/my-therapy-sessions" element={<AuthPage />} />}
          {user.user_id && <Route path="/my-therapy-sessions" element={<MyTherapySessions />} />}

          {/* Dashboard Routes */}
          {user.user_id && <Route path="/dashboard" element={<Dashboard />} />}
          {user.user_id && <Route path="/therapist-dashboard" element={<TherapistDashboard />} />}
          {user.user_id && <Route path="/client-dashboard" element={<ClientDashboard />} />}
          {user.user_id && <Route path="/wallet" element={<WalletPage />} />}
          {user.user_id && <Route path="/manage-users" element={<Dashboard />} />}
          {user.user_id && <Route path="/manage-applications" element={<Dashboard />} />}


          {user.user_id && <Route path="/goals" element={<GoalsDashboard />} />}

          {/* Messages Routes */}
          {user.user_id && <Route path="/messages" element={<MessagesPage />} />}
          {user.user_id && <Route path="/messages/requests" element={<MessageRequestsPage />} />}
          {user.user_id && <Route path="/messages/:userId" element={<ChatPage />} />}

          {/* Groups Routes */}
          {user.user_id && <Route path="/groups/join/:code" element={<Groups />} />}
          {!user.user_id && <Route path="/groups/join/:code" element={<AuthPage />} />}
          {user.user_id && <Route path="/groups" element={<Groups />} />}
          {user.user_id && <Route path="/group" element={<Groups />} />}
          {user.user_id && <Route path="/find-church" element={<FindChurch />} />}
          
          {/* Unified Group Route - handles both public URLs and group IDs */}
          <Route path="/group/:groupIdentifier" element={<PublicGroupView />} />
          {user.user_id && <Route path="/group/:groupId/detail" element={<GroupDetail />} />}
          {user.user_id && <Route path="/group/:groupId/announcements" element={<GroupAnnouncements />} />}
          {user.user_id && <Route path="/group/:groupId/chat" element={<GroupChat />} />}
          {user.user_id && <Route path="/group/:groupId/members" element={<GroupMembers />} />}
          {user.user_id && <Route path="/group/:groupId/departments" element={<GroupDepartments />} />}
          {user.user_id && <Route path="/group/:groupId/department/:departmentId" element={<DepartmentDetail />} />}
          {user.user_id && <Route path="/group/:groupId/department/:departmentId/announcements" element={<DepartmentAnnouncements />} />}
          {user.user_id && <Route path="/group/:groupId/department/:departmentId/goals" element={<DepartmentGoals />} />}
          {user.user_id && <Route path="/group/:groupId/prayer-requests" element={<GroupPrayerRequests />} />}
          {user.user_id && <Route path="/group/:groupId/therapy" element={<GroupTherapy />} />}
          {user.user_id && <Route path="/group/:groupId/counselling" element={<GroupCounselling />} />}
          {user.user_id && <Route path="/group/:groupId/counselling/admin" element={<GroupCounsellingAdmin />} />}
          {user.user_id && <Route path="/counsellor-dashboard" element={<CounsellorDashboard />} />}
          {user.user_id && <Route path="/group/:groupId/goals" element={<GroupGoals />} />}
 
          <Route path="/about" element={<AboutPage />} />

          <Route path="/mobile_app" element={<MobileAppPage />} />

          <Route path="/privacy-policy" element={<PrivacyPage />} />

          <Route path="/terms-of-service" element={<TermsPage />} />

          <Route path="/child-safety-standards" element={<ChildSafetyStandardsPage />} />

          <Route path="/support" element={<DonatePage />} />

          <Route path="/confirm-email/:email/:passcode" element={<AuthPage />} />

          <Route path="/search/:query" element={<SearchPage />} />

          <Route path="/search" element={<SearchPage />} />

          <Route path="/:username" element={<Profile />} />

          <Route path="/:username/insight/:insight_id" element={<Insight />} />
         
         </Routes>

         {/* In-app pop-up notifications */}
         {user.user_id && <NotificationToast />}
         <UpdateNotification />

      </BrowserRouter>

  );
}

export default App;
